import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Phone, Mail } from "lucide-react";

const LINKS = [
  { id: "home", label: "Home" },
  { id: "la-palestra", label: "La Palestra" },
  { id: "sala-pesi", label: "Sala Pesi" },
  { id: "sala-posing", label: "Sala Posing" },
  { id: "zona-relax", label: "Zona Relax" },
  { id: "abbonamenti", label: "Abbonamenti" },
  { id: "coaching", label: "Coaching 1:1" },
  { id: "gift-card", label: "Gift Card" },
  { id: "logbook", label: "Logbook" },
  { id: "brand", label: "I Nostri Brand" },
  { id: "contatti", label: "Contatti" },
];

export default function SideDrawer({ onNavigate }) {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => onNavigate(id), 300);
  };

  return (
    <>
      <button
        data-testid="menu-open-button"
        onClick={() => setOpen(true)}
        className="fixed top-6 left-6 z-[70] flex items-center gap-3 bg-ink/60 backdrop-blur-xl border border-[rgba(176,132,51,0.35)] px-5 py-3 group hover:border-gold transition-colors duration-300"
        aria-label="Apri il menu"
      >
        <span className="flex flex-col gap-1.5">
          <span className="block h-[2px] w-6 bg-gold transition-all duration-300 group-hover:w-4" />
          <span className="block h-[2px] w-6 bg-bone transition-all duration-300 group-hover:w-6" />
        </span>
        <span className="font-display text-lg tracking-[0.25em] text-bone">MENU</span>
      </button>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              data-testid="drawer-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={() => setOpen(false)}
              className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm"
            />
            <motion.aside
              data-testid="side-drawer"
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", damping: 30, stiffness: 260 }}
              className="fixed top-0 left-0 bottom-0 z-[90] w-[86vw] max-w-md bg-[#0a0a0a]/95 backdrop-blur-xl border-r border-[rgba(176,132,51,0.25)] flex flex-col"
            >
              <div className="flex items-center justify-between px-8 pt-8">
                <img src="/assets/logo-fs.png" alt="Full Stack" className="h-14 w-14 object-contain" />
                <button
                  data-testid="menu-close-button"
                  onClick={() => setOpen(false)}
                  aria-label="Chiudi il menu"
                  className="p-2 border border-[rgba(176,132,51,0.35)] text-bone hover:text-gold hover:border-gold transition-colors duration-300"
                >
                  <X size={20} />
                </button>
              </div>

              <nav className="flex-1 overflow-y-auto px-8 py-10 flex flex-col gap-1">
                {LINKS.map((link, i) => (
                  <motion.button
                    key={link.id}
                    data-testid={`drawer-link-${link.id}`}
                    initial={{ opacity: 0, x: -24 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.08 + i * 0.045, duration: 0.4 }}
                    onClick={() => go(link.id)}
                    className="group flex items-baseline gap-4 py-2 text-left"
                  >
                    <span className="font-editorial italic text-gold/70 text-sm w-7">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-3xl md:text-4xl tracking-wide text-bone/80 group-hover:text-gold group-hover:translate-x-2 transition-all duration-300">
                      {link.label.toUpperCase()}
                    </span>
                  </motion.button>
                ))}
              </nav>

              <div className="px-8 pb-8 pt-6 border-t border-[rgba(176,132,51,0.2)] flex flex-col gap-2 text-sm text-bone/60">
                <span className="flex items-center gap-2">
                  <Phone size={14} className="text-gold" /> 346 544 9988
                </span>
                <span className="flex items-center gap-2">
                  <Mail size={14} className="text-gold" /> fullstackgym26@gmail.com
                </span>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
